import { createSlice } from "@reduxjs/toolkit";
import socketFactory from "../../../utils/socketFactory";

const initialState = {
  list: [],
};

const reactionSlice = createSlice({
  name: "reactions",
  initialState,
  reducers: {
    addReaction: (state, action) => {
      state.list.push(action.payload);
    },

    removeReaction: (state, action) => {
      state.list = state.list.filter((r) => r.id !== action.payload);
    },

    sendReaction: {
      reducer(state, action) {
        if (!action.payload) return;
        state.list.push(action.payload);
      },

      prepare({ sender, senderName, roomId, emoji, gif }) {
        socketFactory.socket?.emit("sendReactionToRoom", {
          sender,
          senderName,
          roomId,
          emoji,
          gif,
        });

        return {
          payload: {
            id: Date.now() + Math.random(),
            sender,
            senderName,
            emoji,
            gif,
            time: Date.now(),
          },
        };
      },
    },

RECEIVE_REACTION: (state, action) => {
  const { id, sender, senderName, emoji, gif, time } = action.payload;
  const alreadyExists = state.list.some(
    (r) => r.sender === sender && r.time === time
  );

  if (alreadyExists) return;

  state.list.push({
    id,
    sender,
    senderName,
    emoji,
    gif,
    time,
  });
},

  },
});

export const { addReaction, removeReaction, sendReaction, RECEIVE_REACTION } =
  reactionSlice.actions;

socketFactory.on("receiveReaction", ({ data }) => {
  return RECEIVE_REACTION({
    id: Date.now() + Math.random(),
    sender: data.sender,
    senderName: data.senderName,
    emoji: data.emoji,
    gif: data.gif,
    time: data.time ?? Date.now(),
  });
});

export default reactionSlice.reducer;
